import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Sheet, Button } from '@sm/wds-react';
import classNames from 'classnames';
import { IconMenu, IconX } from '@wds/icons';

import './mobile-menu.scss';

export const MobileDrawer = ({ menuColor, children }) => {
  const [drawerOpen, setOpen] = useState(false);
  const toggleDrawer = () => setOpen(!drawerOpen);

  const buttonClass = classNames(
    'sm-mobile-menu__trigger',
    `sm-mobile-menu__cta`,
    `sm-mobile-menu--${menuColor}`,
    `wds-float--left`
  );

  return (
    <>
      <Button
        variant="text"
        size="sm"
        className={buttonClass}
        onClick={toggleDrawer}
      >
        {drawerOpen ? <IconX /> : <IconMenu />}
      </Button>
      <Sheet
        show={drawerOpen}
        onClose={toggleDrawer}
        placement="left"
        offsetTop={50}
      >
        {children}
      </Sheet>
    </>
  );
};

MobileDrawer.propTypes = {
  menuColor: PropTypes.oneOf(['alt', 'secondary']),
  children: PropTypes.node.isRequired,
};

MobileDrawer.defaultProps = {
  menuColor: 'alt',
};

export default MobileDrawer;
